import { styled } from "@mui/material";

export const ScreenShareControlBar = styled("div")(({ theme }) => ({
  color: "#fff",
  padding: "10px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
  borderRadius: "14px",
  backgroundColor: "rgba(100, 100, 100, 0.6)",
  top: "2vh",
  position: "fixed",
  width: "20%",
  left: "40%",
  zIndex: 20,
  [theme.breakpoints.down("sm")]: {
    left: "10vw",
    top: "75%",
    width: "80% !important",
  },
  "& .share-bar-canvas": {
    width: "95px",
    height: "55px",
    borderRadius: "5px",
    border: "1px solid #23d959",
  },
  "& button": {
    marginLeft: 10,
    backgroundColor: "rgba(42, 93, 247, 0.75)",
  },
}));
